import { z } from 'zod';

export const requiredText = z.string().trim().min(1, 'validation.required');
// Empty in the form, null for the API, which doesn't take empty strings.
export const optionalText = z
    .string()
    .trim()
    .transform((value) => value || null);

export const emailText = z.string().trim().toLowerCase().pipe(z.email('validation.email'));

// Empty in the form (a new form, or a value the extraction missed), but required on submit. The output leaves out null,
// so the submitted values need no `!`.
export const required = <T extends z.ZodType>(schema: T) =>
    schema.nullable().transform((value, context) => {
        if (value === null || value === '') {
            context.addIssue({ code: 'custom', message: 'validation.required' });
            return z.NEVER;
        }
        return value;
    });
